import { useState, useEffect, useRef } from 'react';
import { FaCheckCircle, FaChevronRight } from 'react-icons/fa';
import axios from 'axios';
import { API_BASE_URL } from '../../Api/config';
import { useNavigate } from 'react-router-dom';
import searchIconImage from "../../Assets/icon/freeTenderSearchIcon.png";

const Departments = ({ handleDepartmentSelect }) => {
  const [departments, setDepartments] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [expandedDepartment, setExpandedDepartment] = useState(null);
  const [loadingDepartments, setLoadingDepartments] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredDepartments, setFilteredDepartments] = useState([]);

  const departmentRefs = useRef([]);
  const navigate = useNavigate();

  const fetchDepartments = async () => {
    try {
      setLoadingDepartments(true);
      const response = await axios.get(`${API_BASE_URL}/user/visitor/department`);
      const filterByStatus = response.data?.data?.filter(dept => dept.department_status === 1);
      const departments = filterByStatus || [];
      setDepartments(departments);
      setFilteredDepartments(departments);

      if (departments.length > 0) {
        setSelectedDepartment(departments[0].id);
      }
    } catch (err) {
      console.error('Failed to fetch departments.', err);
    } finally {
      setLoadingDepartments(false);
    }
  };

  const handleDepartmentSelector = (departmentId, index) => {
    if (expandedDepartment === departmentId) {
      setExpandedDepartment(null);
    } else {
      setSelectedDepartment(departmentId);
      setExpandedDepartment(departmentId);
    }
    // Scroll to the selected department and center it
    if (departmentRefs.current[index]) {
      departmentRefs.current[index].scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  const handleSubdepartmentSelect = SubDepartmentName => {

    navigate('/limitedTenderView', { state: { SubDepartmentName } });
    window.scrollTo(0, 0);
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    const filtered = departments.filter(department =>
      department.name.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredDepartments(filtered);
  };

  useEffect(() => {
    fetchDepartments();
  }, []);

  return (
    <div className="min-h-screen py-2 mx-1 my-2">
      <h1 className="text-xs sm:text-sm md:text-xl text-center mb-2 mx-10">
        Choose any sub-department of a department to view Tenders
      </h1>

      {/* Main Content */}
      <div className="w-full  mx-auto px-4 ">

        {/* Search Box */}
        <div className="relative flex items-center w-full  mb-3">
          <div className="absolute right-4 md:w-8 md:h-8 w-6 h-6 rounded-full bg-blue-500 flex items-center justify-center">
            <img src={searchIconImage} alt="Icon" className="md:w-4 md:h-4 w-3 h-3 " />
          </div>
          <input
            placeholder="Search by Department..."
            value={searchTerm}
            onChange={handleSearchChange}
            type="text"

            className="flex-1 border border-gray-300 rounded-full px-3 pr-4 md:py-2 py-1 focus:outline-none focus:ring-2 focus:ring-blue-600 text-sm sm:text-base w-full"
          />
        </div>

      </div>

      {/* Departments List */}
      {loadingDepartments ? (
        <div className="text-center py-4">Loading departments...</div>
      ) : (
        <div>
          <h2 className="font-bold text-xs sm:text-sm md:text-lg sm:text-center md:text-left w-full ms-6">All Department</h2>
          <div className="flex flex-col gap-4 md:px-4 lg:px-6 mt-4 max-h-[calc(100vh-100px)] overflow-y-auto">
            {filteredDepartments.length > 0 ? (
              filteredDepartments.map((department, deptIndex) => (
                <div key={department.id} className="border-b" ref={el => departmentRefs.current[deptIndex] = el}>
                  <div
                    onClick={() => handleDepartmentSelector(department.id, deptIndex)}
                    className="cursor-pointer  bg-gray-100 transition-all"
                  >
                    <h3
                      className={`flex items-center gap-2 rounded-lg text-xs md:text-sm text-gray-700 p-3 py-2 hover:bg-blue-500 hover:text-white transition-all ${expandedDepartment === department.id ? 'bg-blue-700 text-white' : 'bg-gray-100'
                        }`}
                    >
                      <FaChevronRight className={`transition-transform duration-300 transform ${expandedDepartment === department.id ? 'rotate-90' : ''
                        }`} /> {deptIndex + 1}. {department.name}

                      {expandedDepartment === department.id && <FaCheckCircle className="text-white" />}
                    </h3>
                  </div>

                  {expandedDepartment === department.id && (
                    <div className="transition-all duration-500 ease-in-out">
                      {department.sub_departments && department.sub_departments.length > 0 ? (
                        <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-3 gap-4">
                          {department.sub_departments.map((subDept, subIndex) => {
                            const isSubDeptValid = subDept.name !== null && subDept.name.trim() !== '';

                            return (
                              <div key={subDept.id} className="cursor-pointer ps-10 transition-all mt-2 ">
                                <h5
                                  onClick={() => handleDepartmentSelect(subDept.name)}
                                  className={`my-2 ps-2 py-2 text-xs md:text-sm rounded-lg mb-2 cursor-pointer transition-all 
    ${isSubDeptValid ? 'bg-blue-300 text-black hover:bg-blue-400' : 'bg-gray-200 text-gray-600'}`}
                                >

                                  {isSubDeptValid && ` Sub Department ${subIndex + 1} : `}

                                  {/* Apply red color when no name is available */}
                                  <span className={subDept.name ? 'text-black' : 'text-red-500'}>
                                    {subDept.name || 'No SubDepartment available'}
                                  </span>
                                </h5>

                              </div>
                            );
                          })}
                        </div>
                      ) : (
                        <p className="text-red-600 ms-6 mt-2">No sub-departments available</p>
                      )}
                    </div>
                  )}
                </div>
              ))
            ) : (
              <p className="text-red-600 ms-6 mt-2" >No departments available.</p>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Departments;

// import React, { useState, useEffect, useRef } from 'react';
// import { useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import { API_BASE_URL } from '../../Api/config';
// import { IoIosArrowDown, IoMdSearch } from "react-icons/io";
// import { GoDotFill } from "react-icons/go";
// import { IoSearchCircleOutline } from 'react-icons/io5';
// import { FaCheckCircle, FaSearch } from 'react-icons/fa';
// import NotFoundPic from "../../Assets/images/tenderNotFoundImage.png"



// const Department = ({ handleDepartmentSelect }) => {
//   const [departments, setDepartments] = useState([]);
//   const [departmentName, setDepartmentName] = useState('');
//   const [subDepartments, setSubDepartments] = useState([]); // Store subDepartments here
//   const [selectedDepartment, setSelectedDepartment] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState('');
//   const [searchTerm, setSearchTerm] = useState('');
//   const [filteredDepartments, setFilteredDepartments] = useState([]);
//   const [activeSubDepartment, setActiveSubDepartment] = useState(null); // Store the active sub_department
//   const [openIndex, setOpenIndex] = useState(null); // Track which FAQ is open

//   const navigate = useNavigate();

//   // const handleDepartmentSelect = SubDepartmentName => {
//   //   // Navigate to the LimitedTenderView page and pass the selected category name
//   //   navigate('/limitedTenderView', { state: { SubDepartmentName } });
//   //   window.scrollTo(0, 0);
//   // };

//   const fetchDepartments = async () => {
//     try {
//       setLoading(true);
//       const response = await axios.get(
//         `${API_BASE_URL}/user/visitor/department`
//       );
//       const filterByStatus = response.data?.data?.filter(
//         tender => tender.department_status === 1
//       );
//       const departments = filterByStatus || [];
//       setDepartments(departments);
//       setFilteredDepartments(departments);

//       if (departments.length > 0) {
//         setSelectedDepartment(departments[0].id);
//         setDepartmentName(departments[0].name);
//         fetchsubDepartments(departments[0].sub_departments);
//       }
//     } catch (err) {
//       setError('Failed to fetch departments.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchsubDepartments = subDepartments => {
//     if (subDepartments) {
//       setSubDepartments(subDepartments); // Set the sub_departments as subDepartments
//     }
//   };

//   const handleDepartmentChange = (department, departmentId, departmentName) => {
//     setSelectedDepartment(departmentId);
//     setDepartmentName(departmentName);
//     fetchsubDepartments(department.sub_departments); // Fetch sub_departments when department changes
//   };

//   const handleSearchChange = e => {
//     const value = e.target.value;
//     setSearchTerm(value);

//     const filtered = departments.filter(department =>
//       department.name.toLowerCase().includes(value.toLowerCase())
//     );
//     setFilteredDepartments(filtered);
//   };

//   useEffect(() => {
//     fetchDepartments();
//   }, []);

//   const toggleAccordion = sub_departmentId => {
//     setOpenIndex(openIndex === sub_departmentId ? null : sub_departmentId);
//     setActiveSubDepartment(sub_departmentId);
//   };

//   return (
//     <div>
//       <div className=" pt-1">
//         <div className="flex flex-col md:flex-row  md:justify-between mx-10 my-2 items-center gap-2">
//           <h1 className=" text-xm sm:text-sm md:text-2xl lg:text-xl border-b-2 border-gray-500  text-start ">
//             All Departments
//           </h1>

//           <div className="flex items-center justify-center px-4 w-full md:w-1/2 lg:w-1/2">
//             <div className="relative w-full ">
//               <input
//                 value={searchTerm}
//                 onChange={handleSearchChange}
//                 type="text"
//                 placeholder="Department Name"
//                 className="w-full  py-1 md:py-2 pl-4 pr-12 border border-gray-400 rounded shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
//               />
//               <button className="absolute inset-y-0 right-1 m-1 px-2 text-white bg-modalHeader rounded hover:bg-blue-700">
//                 <div className="flex gap-1 items-center text-sm md:text-base lg:text-lg">
//                   <FaSearch className="w-3 h-3 md:w-4 md:h-4 lg:w-5 lg:h-5" />
//                   <span className="hidden sm:inline lg:inline md:inline">
//                     Search
//                   </span>
//                 </div>
//               </button>
//             </div>
//           </div>
//         </div>

//         {/* <div className="flex items-center justify-center px-4 w-full md:w-1/2 lg:w-1/2">
//           <div className="relative w-full ">
//             <input
//               value={searchTerm}
//               onChange={handleSearchChange}
//               type="text"
//               placeholder="Department Name"
//               className="w-full  py-1 md:py-2 pl-4 pr-12 border border-gray-400 rounded shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
//             />
//             <button className="absolute inset-y-0 right-1 m-1 px-2 text-white bg-modalHeader rounded hover:bg-blue-700">
//               <div className="flex gap-1 items-center text-sm md:text-base lg:text-lg">
//                 <FaSearch className="w-3 h-3 md:w-4 md:h-4 lg:w-5 lg:h-5" />
//                 <span className="hidden sm:inline lg:inline md:inline">
//                   Search
//                 </span>
//               </div>
//             </button>
//           </div>
//         </div> */}
//       </div>

//       <div
//         className={`gap-2 mx-2 md:mx-7 gap-x-5 md:gap-x-14 lg:gap-x-20 lg:mx-9 my-4 md:text-sm text-xs px-4 h-[200px] md:h-[250px] lg:h-[300px] overflow-y-auto`}
//       >
//         {loading ? (
//           <div className="flex justify-center gap-5 items-center">
//             <p className="text-lg">Loading...</p>
//           </div>
//         ) : filteredDepartments.length > 0 ? (
//           <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3  gap-4  gap-x-5 md:gap-x-24 lg:gap-x-28">
//             {filteredDepartments.map((department, index) => (
//               <div
//                 key={department.id}
//                 onClick={() =>
//                   handleDepartmentChange(
//                     department,
//                     department.id,
//                     department.name
//                   )
//                 }
//                 className={`flex flex-col items-start justify-start py-2 rounded-md cursor-pointer ${
//                   selectedDepartment === department.id
//                     ? 'bg-modalHeader text-white'
//                     : 'bg-slate-100 text-gray-600'
//                 }`}
//               >
//                 <div className="flex items-center px-3">
//                   <h2 className="md:text-sm text-left text-xs md:mt-1 mt-2 flex items-center gap-2">
//                     <span
//                       className={`${
//                         selectedDepartment === department.id
//                           ? 'text-white'
//                           : 'text-gray-600'
//                       }`}
//                     >
//                       {' '}
//                       {index + 1}. {department.name}{' '}
//                     </span>{' '}
//                     {selectedDepartment === department.id && (
//                       <FaCheckCircle className="text-white text-sm md:text-base" />
//                     )}
//                   </h2>
//                 </div>
//               </div>
//             ))}
//           </div>
//         ) : (
//           <div className="flex justify-center items-center h-full">
//             <img
//               className="max-w-full h-full"
//               src={NotFoundPic}
//               alt="Not Found"
//             />
//           </div>
//         )}
//       </div>

//       <div
//         className="flex flex-col items-start md:flex-row gap-4 px-6 pt-2 mt-5  bg-white rounded-t-lg min-h-auto"
//         style={{ minHeight: '60vh' }}
//       >
//         {/* Sidebar for subDepartments */}
//         <div
//           className="bg-white shadow-md rounded-lg p-4 w-full md:w-1/4 overflow-y-auto"
//           style={{ maxHeight: '80vh' }}
//         >
//           <h2 className="text-xm sm:text-sm md:text-2xl lg:text-xl border-b-2 border-gray-500  text-start mb-4">
//             Department:
//           </h2>
//           <ul className="space-y-2">
//             <h1 className="text-start rounded py-2 px-3 bg-blue-400 text-lg text-white">
//               {departmentName}
//             </h1>
//           </ul>
//         </div>

//         {/* FAQ Section */}
//         <div
//           className="bg-white rounded w-full md:w-3/4 overflow-y-auto"
//           style={{ maxHeight: '80vh' }}
//         >
//           <h1 className="text-start rounded mb-2 py-2 px-3 bg-modalHeader text-lg text-white">
//             Sub Departments
//           </h1>
//           {subDepartments.length > 0 ? (
//             subDepartments.map(sub_department => (
//               <div key={sub_department.id}>
//                 <div
//                   className="cursor-pointer p-3 mb-2 font-semibold text-gray-700 bg-faqSectionBg"
//                   onClick={() => toggleAccordion(sub_department.id)}
//                 >
//                   {sub_department.name && (
//                     <h2
//                       onClick={() => {
//                          handleDepartmentSelect(sub_department.name);
//                         window.scrollTo(0, 0);
//                       }}
//                       className="flex items-center gap-3 hover:text-modalHeader cursor-pointer"
//                     >
//                       {subDepartments.indexOf(sub_department) + 1} .{' '}
//                       {sub_department.name}
//                     </h2>
//                   )}
//                 </div>
//               </div>
//             ))
//           ) : (
//             <div className="flex justify-center items-center h-1/2">
//               <img
//                 className="max-w-full h-full"
//                 src={NotFoundPic}
//                 alt="Not Found"
//               />
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Department;
